// extracted by mini-css-extract-plugin
export default {"list":"list__Q0hN1"};